import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import RestaurantMenuCard from "../components/RestaurantMenuCard";
import rest1 from "../assets/images/rest1.webp";
import rest2 from "../assets/images/rest2.webp";
import rest3 from "../assets/images/rest3.webp";
import rest4 from "../assets/images/rest4.webp";
import food1 from "../assets/images/food1.webp";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import Star from "../assets/icons/Star";
import client from "../assets/images/client.png";
import Search from "../assets/icons/Search";
import CartSummary from "../components/CartSummary";
import { get, post, postWithImage } from "../network/api";
import moment from "moment";
import { useTranslation } from "react-i18next";

import { usePlaceOrder } from "../context/OrderContext";
const categoryMenu = [
  "Pasta",
  "Burger",
  "Drinks",
  "Sweets",
  "Noodles",
  "Snacks",
  "Rice",
  "Lorem",
  "Ipsum",
  "Pizza",
  "Fries",
  "Wraps",
];

const SingleRestaurant = () => {
  const {t} = useTranslation();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const restaurantId = params.get("id");

  const [restaurantDetail, setRestaurantDetail] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cart, setCart] = useState({});
  const { order, setrestaurant,setDeal } = usePlaceOrder();
  
  const moment = require('moment'); // or use dayjs

function getRestaurantStatus(restaurantHours) {
  if(restaurantHours==undefined)return { isOpen: false, message: 'No hours available' };
  console.log("restaurantHours", restaurantHours);
  const now = moment(); // current time
  const today = now.format('dddd'); // "Monday", "Tuesday", etc.
  console.log("today", today);
  const todayHours = restaurantHours[today];
  if (!todayHours) return { isOpen: false, message: 'Closed today' };

  const nowTime = moment(now.format('HH:mm'), 'HH:mm');
  const openTime = moment(todayHours.openTime, 'hh:mm A');
  const closeTime = moment(todayHours.closeTime, 'hh:mm A');

  // Check if current time is within open hours
  const isInMainHours = nowTime.isBetween(openTime, closeTime);

  // Check if within break time
  const inBreak = (todayHours.break || []).some(b => {
    const breakStart = moment(b.start, 'hh:mm A');
    const breakEnd = moment(b.end, 'hh:mm A');
    return nowTime.isBetween(breakStart, breakEnd);
  });

  if (isInMainHours && !inBreak) {
    // Generate time slots (every 30 min)
    const slots = [];
    let slotTime = openTime.clone();
    while (slotTime.isBefore(closeTime)) {
      // skip break slots
      const isDuringBreak = (todayHours.break || []).some(b => {
        const breakStart = moment(b.start, 'hh:mm A');
        const breakEnd = moment(b.end, 'hh:mm A');
        return slotTime.isBetween(breakStart, breakEnd, undefined, '[)');
      });

      if (!isDuringBreak) {
        slots.push(slotTime.format('hh:mm A'));
      }
      slotTime.add(30, 'minutes');
    }

    return {
      isOpen: true,
      timeSlots: slots.filter(t => moment(t, 'hh:mm A').isAfter(nowTime))
    };
  } else {
    // If closed, find next open time for today
    if (nowTime.isBefore(openTime)) {
      return {
        isOpen: false,
        nextOpenTime: openTime.format('hh:mm A')
      };
    } else {
      return {
        isOpen: false,
        message: t("closed_for_today")
      };
    }
  }
}

  

  useEffect(() => {
    getRestaurantDetail();
  }, []);

  async function getRestaurantDetail() {
    try {
      const data = await post(`customer/restaurants/${restaurantId}`);
      console.log(data);
      setRestaurantDetail(data); // Store data in state
      setrestaurant(data.restaurant); 
      setDeal(data.deal);
      
      // Store data in state
      setMenuItems(data.menu);
      setLoading(false);
    } catch (e) {
      console.error("Error fetching restaurant details:", e);
      // setError(error.message); // Handle any errors
      setLoading(false);
    }
  }
  const [query, setQuery] = useState("");

  const handleSearch = async () => {
    if (!query) {
      setMenuItems(restaurantDetail.menu);
      return;
    }
    const filteredItems = restaurantDetail.menu.filter((item) =>
      item.name?.toLowerCase().includes(query.toLowerCase())
    );
    setMenuItems(filteredItems);
  };

  const onItemClick = (data) => {
    console.log(data);
    data = {
      ...data,
      data,
    };
    setCart(data);
  };

  const [selectedOption, setSelectedOption] = useState("veg");
  return (
    <React.Fragment>
      <section className="rest_detail_section bg-custom">
        <div className="wrapper">
          <div className="rest_detail_flex">
            <div className="rest_image_slider">
              <Swiper
                pagination={{ clickable: true }}
                loop={true}
                spaceBetween={10}
                autoplay={{ delay: 4000 }}
                modules={[Pagination, Autoplay]}
                className="mySwiper">
                {restaurantDetail?.restaurant?.restaurant_banner.map(
                  (rest, index) => (
                    <SwiperSlide key={index}>
                      <div className="img_container">
                        <img src={rest} alt={rest} />
                      </div>
                    </SwiperSlide>
                  )
                )}
              </Swiper>
            </div>
            <div className="rest_details_container">
              <h1 className="subtitle_common rest_heading_content">
                {restaurantDetail?.restaurant?.restaurant_name ?? ""}
              </h1>
              <p className="para_common rest_content">
                {restaurantDetail?.restaurant?.restaurant_tagline ?? ""}
              </p>
              <div className="rest_timing_flex">
                <span className="rates_rest">
                  <Star />
                  {restaurantDetail?.restaurant?.averageRating
                    ? restaurantDetail.restaurant.averageRating.toFixed(2)
                    : "NaN"}{" "}
                  Ratings
                </span>
                {restaurantDetail?.restaurant != null && (
  <p className="open_close_time">
    {
      (() => {
        const status = getRestaurantStatus(restaurantDetail?.restaurant?.restaurantHours);
        if (status?.isOpen) {
          return "Open now";
        } else if (status?.nextOpenTime) {
          return `Opens at ${status.nextOpenTime}`;
        } else if (status?.message) {
          return status.message;
        } else {
          return "Currently closed";
        }
      })()
    }
  </p>
)}

                
                {/* <p className="open_close_time">Open Now 8:00AM TO 9:00PM</p> */}
              </div>
              <div className="review_rest">
                <ul>
                  <li>{t("review")}</li>
                </ul>
                <div className="review_list">
                  {restaurantDetail?.reviews?.map((review, index) => (
                    <div className="review_card">
                      <div className="review_container">
                        <div className="reviewer_container">
                          <div className="test_img">
                            <img src={client} alt="client" />
                          </div>
                          <div>
                            <p className="test_name">{review.user.full_name}</p>
                            {/* <p className="test_de">Lorem Ipsum</p> */}
                          </div>
                        </div>
                        <div className="start_rest">
                          {[...Array(review.overallRating)].map((_, index) => (
                            <Star key={index} color={index < 3 ? "gold" : "red"} />

                          ))}
                        </div>
                      </div>
                      <p className="review_text">{review.comment}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="wrapper">
        <div className="flex_box_container rest_menu_heading">
          <div className="cta_input">
            <div className="input_full">
              <input
                type="text"
                className="input_cta"
                name="search"
                id="search"
                onChange={(e) => setQuery(e.target.value)}
                value={query}
                placeholder={t("search_food_here")}
              />
              <button className="btn btn-primary" onClick={handleSearch}>
                <Search /> <span>{t('search')}</span>
              </button>
            </div>
          </div>

          {/* <div className="category_menu_slider">
            <Swiper
              spaceBetween={20}
              slidesPerView={6}
              autoplay={{ delay: 3000 }}
              navigation={true}
              loop={true}
              modules={[Navigation, Autoplay]}
              breakpoints={{
                320: {
                  slidesPerView: 2,
                },
                576: {
                  slidesPerView: 4,
                },
                1024: {
                  slidesPerView: 5,
                },
                1500: {
                  slidesPerView: 6,
                },
              }}
            >
              {categoryMenu.map((category, index) => (
                <SwiperSlide key={index}>
                  <div className="category_item">
                    <p>{category}</p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div> */}
        </div>
      </div>

      
      
      <section className="rest_menu_section">
        <div className="wrapper">
          <div className="title-flex-group">
            <h2 className="subtitle_common">{t('order_online')}</h2>
            {/* <div className="radio-group">
              <label className="radio-label">
                <input
                  type="radio"
                  name="foodType"
                  value="veg"
                  checked={selectedOption === "veg"}
                  onChange={() => setSelectedOption("veg")}
                />
                <span className="custom-radio veg"></span>
                Veg
              </label>

              <label className="radio-label">
                <input
                  type="radio"
                  name="foodType"
                  value="nonveg"
                  checked={selectedOption === "nonveg"}
                  onChange={() => setSelectedOption("nonveg")}
                />
                <span className="custom-radio nonveg"></span>
                Non-Veg
              </label>
            </div> */}
          </div>

          <div className="flex-container-card">
            <div className="item_list_grid">
              {menuItems?.map((restaurant, index) => (
                <RestaurantMenuCard
                  key={index}
                  restaurant={restaurant}
                  // foodName={restaurant.food}
                  // description={restaurant.description}
                  // rating={restaurant.rating}
                  // price={restaurant.price}
                  // isVeg={restaurant.isVeg}
                  // foodImage={restaurant.image}
                  // onItemAdded={onItemClick}
                />
              ))}
            </div>
            <CartSummary />
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default SingleRestaurant;
